import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BuyContractService } from '../buy-contract.service';
import { TupleReport } from '../buy-contract.type';

/**
 * Suppliers' "I won't buy this tuple" reports. Filtering by one supplier is the
 * abuse check: someone reporting almost everything they are given shows up here.
 */
@Component({
  selector: 'app-tuple-reports-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  templateUrl: './tuple-reports-dialog.html',
  styleUrl: './tuple-reports-dialog.scss'
})
export class TupleReportsDialog implements OnInit {
  reports: TupleReport[] = [];
  total = 0;
  pageIndex = 0;
  pageSize = 20;
  loading = true;
  reporter: { id: string; username: string } | null = null;

  constructor(
    private dialogRef: MatDialogRef<TupleReportsDialog>,
    private service: BuyContractService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.listTupleReports(this.pageIndex, this.pageSize, this.reporter?.id).subscribe({
      next: res => {
        this.reports = res.items;
        this.total = res.total;
        this.loading = false;
      },
      error: () => {
        this.snackBar.open('Error loading tuple reports', 'Close', { duration: 5000 });
        this.loading = false;
      }
    });
  }

  onPage(e: PageEvent): void {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.load();
  }

  filterBy(r: TupleReport | null): void {
    this.reporter = r ? { id: r.reporter_id, username: r.reporter_username } : null;
    this.pageIndex = 0;
    this.load();
  }

  close(): void {
    this.dialogRef.close();
  }

  formatDate(d?: string): string {
    if (!d) return '—';
    return new Date(d).toLocaleString();
  }
}
